import React from 'react';

const About = () => {
    return (
        <section className="about" id="about">
            <div className="container">
                <div className="section-title">
                    <h2>THAKSHA</h2>
                    <p>Shaping Dreams into Spaces</p>
                </div>

                <div className="about-content">
                    <div className="about-text">
                        <h3>Thaksha Architects</h3>
                        <p>
                            Based in Muvattupuzha, Kerala, Thaksha Architects is an architectural and interior design firm 
                            dedicated to transforming visions into meaningful spaces. We believe every space has a story, 
                            and great design is the art of telling that story beautifully, functionally, and sustainably.
                        </p>
                        <p>
                            Our philosophy begins with people. By working closely with clients, we craft spaces that are 
                            not only visually striking but also deeply personal and practical. From <strong>conceptual design</strong> 
                            and <strong>3D modeling</strong> to <strong>project planning</strong> and <strong>execution</strong>, 
                            our holistic approach ensures seamless and inspiring results.
                        </p>
                        <p>
                            With a strong emphasis on quality and sustainability, we use premium materials and innovative 
                            design strategies to create spaces that inspire and endure. Proudly located in Muvattupuzha, 
                            Ernakulam, Thaksha Architects continues to shape spaces that reflect individuality, 
                            functionality, and timeless design.
                        </p>

                        <a href="#contact" className="btn" style={{marginTop: '20px'}}>Contact</a>
                    </div>

                    <div className="about-img">
                        <img src="/images/thaksha--.jpg" alt="Thaksha Team" />
                    </div>
                </div>

                <div className="founder-section">
                    <div className="founder-img">
                        <img src="/images/rubense.png" alt="Founder of Thaksha Architects" />
                    </div>
                    <div className="founder-details">
                        <h3>Ar.Rubense Paul</h3>
                        <div className="title">Founder & Principal Architect</div>
                        <p>B-Arch from VTU Belgaum | Member, Council of Architecture (CA2009/45340) | AIIA 19105</p>
                        <br></br>
                        <p>With over 15 years of experience in architectural design and project management, Rubin leads Thaksha Architects with a vision to create spaces that inspire and endure. His expertise spans residential, commercial, and institutional projects, with a special focus on sustainable design principles.</p>
                        
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;